import type { EvaluationsForPosition } from "../engines/analysis-manager";
import { type ClassifyMoveEvaluations } from "../utils/evaluation-util";

const from = (
    evaluations: EvaluationsForPosition
): ClassifyMoveEvaluations => ({
    bestMove: evaluations.evaluationBefore.bestMoveMessage.bestMove,
    evalBefore: evaluations.evaluationBefore.evaluationMessage.score,
    evalAfterBestReply:
        evaluations.afterBestReplyEvaluation.evaluationMessage.score,
    evalAfter: evaluations.evaluationAfter.evaluationMessage.score,
    bestLinesCurrentPosition: evaluations.bestLines,
    bestLinesPreviousPosition: evaluations.previousBestLines,
});

export const ClassifyMoveEvaluationsMapper = {
    from,
};
